import {Spin} from "antd";

import styles from "./page-loader.module.css";

const PageLoader = ()=> {
    return (
        <div className={styles.wrapper}>
            <Spin size="large" />
        </div>
    )
}

export default PageLoader;